export default __webpack_public_path__ + "images/b9432ebe22f8d63183dbf0e56eaf07c5.svg";